import { CloudProviderWorker } from "./CloudProviderWorker";
import { Instance } from "../lib/kotenna/Instance";
import { CloudProvider } from "../lib/kotenna/CloudProvider";
import { VHost } from "../lib/kotenna/VHost";
import { inject, injectable } from "inversify";
import { ConsoleUI } from "../utils/ConsoleUI";
import TYPES from "../TYPES";
import { KotennaApi } from "../lib/kotenna/KotennaApi";
import AWS = require("aws-sdk");

export interface AWSCloudProvider extends CloudProvider {
    accessKeyId: string;
    secretAccessKey: string;
    region: string;
}

@injectable()
export class CFWorker implements CloudProviderWorker {

    private console: ConsoleUI;
    private api: KotennaApi;

    constructor(@inject(TYPES.ConsoleUI) ui: ConsoleUI, @inject(TYPES.KotennaApi) api: KotennaApi) {
        this.console = ui;
        this.api = api;
    }

    async createProvider(): Promise<CloudProvider> {
        const name = await this.console.promptInput("Name for this provider?");
        const accessKeyId = await this.console.promptInput("Access Key");
        const secretAccessKey = await this.console.promptInput("Secret Access Key");
        const region = await this.console.promptInput("Region");

        this.console.loaderStart(`Validating credentials`);
        const me = await this.api.login();

        return new AWS.STS({
            accessKeyId,
            secretAccessKey,
            region
        }).getCallerIdentity().promise()
            .then(res => {
                if (res.Account) {
                    this.console.loaderSuccess("Credentials validated");

                    return this.api.providerSave({
                        api: 'awscf',
                        accessKeyId,
                        secretAccessKey,  
                        region,              
                        name,
                        owner: me
                    });
                }
                else {
                    throw new Error('The profile is not active!');
                }

            });
    }

    async createVhost(hostname: string, stack: Instance, provider: CloudProvider, tpl: any): Promise<VHost> {

        tpl.templateURL  = await this.console.promptInput("Insert the templateURL in S3:");
        
        return Promise.resolve(new VHost({
            hostname,
            node_name: stack.name,
            provider_api: provider.api,
            provider_key: provider.name,
            tpl
        }));
    }
	
    
}